import { useTranslation } from 'react-i18next'
import { SEO } from '@/components/SEO'
import { HeroSection } from './HeroSection'
import { CategoriesGrid } from './CategoriesGrid'
import { FeaturedRecipes } from './FeaturedRecipes'

export function RecipesPage() {
  const { t } = useTranslation('common')

  return (
    <>
      <SEO
        title={t('nav.recipes')}
        description={t('recipes.metaDescription')}
        type="website"
      />
      <main id="main-content">
        <HeroSection />
        <CategoriesGrid />
        <FeaturedRecipes />
      </main>
    </>
  )
}
